import React from 'react';
import { convertStyleData, transformPx2Rem, getGoodsTypeByForm } from '@utils/tools';
import { appMethod as app } from '@utils/app';

import './NewClassifyCustomComponent.less';

export default class NewClassifyCustomComponent extends React.Component {

  constructor(props) {
    super(props);
    let compindex = props.index;
    let pageInstance = app.getAppCurrentPage();
    this.init(compindex, pageInstance);
  }

  init = (compindex, pageInstance) => {
    let that = this;
    let compData = pageInstance.data.eles[compindex];
    let customFeature = compData.customFeature;
    let cateReqUrl = '/index.php?r=appData/getCategoryByGroup';
    let cateParam = {
      group_id: customFeature.classifyGroupId
    };
    let refreshCompIndex = app.findComponentIndexById(customFeature.refresh_object);
    if (refreshCompIndex < 0) {
      console.log('该分类组件没有绑定列表');
      return;
    }
    let refreshCompData = pageInstance.data.eles[refreshCompIndex];
    let refresh_form = refreshCompData.customFeature.form;

    if (customFeature.selectClassifyType == 2) {
      let selfClassifyData = customFeature.classifyList || [];
      this.initNewClassifyGroup(pageInstance, compindex, selfClassifyData, customFeature, refresh_form);
    } else {
      if (cateParam.group_id === '') {
        ;
        // app.showModal({content: '请绑定分类组'})
        app.showToast({
          title: '分类组件未绑定分类组',
          icon: 'none'
        });
      } else {
        if (cateParam.group_id == -1) {
          cateReqUrl = '/index.php?r=AppData/ListCategory';
          if (['goods', 'appointment', 'waimai', 'tostore', 'group_buy'].indexOf(customFeature.refresh_form) > -1) {
            cateParam = {
              form: 'goods',
              goods_type: getGoodsTypeByForm(refresh_form)
            }
          } else {
            cateParam = {
              form: refresh_form
            }
          }
        }
        app.sendRequest({
          hideModal: true,
          hideLoading: true,
          url: cateReqUrl,
          data: cateParam,
          chain: true,
          subshop: pageInstance.franchiseeId || '',
          success: function (res) {
            let classifyData = [],
              form = '';

            if (cateParam.form) {
              classifyData = res.data;
              form = refresh_form;
            } else {
              classifyData = res.data.item;
              form = res.data.form;
              if (customFeature.isManualAddClassify === true) {
                let compContent = compData.content, newClassifyData = [];
                compContent.forEach(function (co) {
                  let newItem = {};
                  let targetItem = classifyData.find(function (cd) {
                    return cd.category_id == co.firstClassifyId;
                  });
                  if (targetItem) {
                    Object.keys(targetItem).forEach(function (k) {
                      newItem[k] = targetItem[k];
                    });
                    if (co.secondClassifyId > 0 && newItem.subclass.length) {
                      newItem.subclass = newItem.subclass.filter(function (sc) {
                        return sc.category_id == co.secondClassifyId;
                      });
                    } else {
                      newItem.subclass.unshift({
                        category_id: co.firstClassifyId,
                        group_id: newItem.group_id,
                        name: '全部',
                        cover: '',
                        pid: 0,
                        weight: 1
                      });
                    }
                  } else {
                    newItem = {};
                  }
                  newClassifyData.push(newItem);
                });
                classifyData = newClassifyData;
              }
            }

            that.initNewClassifyGroup(pageInstance, compindex, classifyData, customFeature, form);
          }
        });
      }
    }

    let newData = {};
    let page_hasNavBar = pageInstance.data.page_hasNavBar;
    if (page_hasNavBar) {
      newData['eles[' + compindex + '].top'] = app.globalData.topNavBarPaddingTop + 80;
      pageInstance.setData(newData);
    }
  }

  initNewClassifyGroup = (pageIns, compindex, cateData, customFeature, form) => {
    let pageInstance = pageIns || app.getAppCurrentPage();
    let classifyData = cateData;
    let classifyLevel = +customFeature.classifyType || 1;
    let selectedIndex = customFeature.selected || 0;
    let categoryId = '';
    let newData = {};

    if (customFeature.selectClassifyType == 2 || (customFeature.selectClassifyType == 1 && customFeature.classifyGroupId == -1)) {
      if (customFeature.classifyType > 1) {
        classifyData = classifyData.map(function (item) {
          return {
            category_id: item.id,
            group_id: '',
            name: item.name,
            pid: 0,
            subclass: item.subclass && item.subclass.map(function (sitem) {
              return {
                category_id: sitem.id,
                group_id: '',
                name: sitem.name,
                pid: item.id
              }
            }) || []
          }
        });
      } else {
        classifyData = classifyData.map(function (item) {
          return {
            category_id: item.id,
            group_id: '',
            name: item.name,
            pid: 0,
            subclass: []
          }
        });
      }
    }

    if (customFeature.selectClassifyType == 1) {
      if (customFeature.showAllClassify) {
        classifyData = classifyData.filter(item => item.category_id);
        if (classifyLevel === 2) {
          classifyData.forEach(item => {
            if (item.subclass[0] && (item.subclass[0].category_id == item.category_id)) {
              item.subclass = item.subclass.slice(1);
            }
          });
        }
      } else {
        if (classifyData[0] && classifyData[0].category_id) {
          classifyData.unshift({
            category_id: '',
            group_id: '',
            name: '全部',
            pid: 0,
            weight: '',
            subclass: []
          });
        }
        if (classifyLevel === 2) {
          classifyData.forEach(item => {
            if (!item.category_id) {
              return;
            }
            if (item.subclass[0] && (item.subclass[0].category_id == item.category_id)) {
              return;
            }
            item.subclass.unshift({
              category_id: item.category_id,
              group_id: '',
              name: '全部',
              pid: 0,
              weight: '',
              subclass: []
            });
          });
        }
      }
    }

    if (classifyData[selectedIndex]) {
      if (classifyLevel > 1) {
        if (classifyData[selectedIndex].subclass && classifyData[selectedIndex].subclass[0]) {
          categoryId = classifyData[selectedIndex].subclass[0].category_id;
        } else {
          categoryId = classifyData[selectedIndex].category_id;
        }
      } else {
        categoryId = classifyData[selectedIndex].category_id;
      }
    }

    newData['eles[' + compindex + '].classifyData'] = classifyData;
    newData['eles[' + compindex + '].classifyGroupForm'] = form || customFeature.refresh_form;
    newData['eles[' + compindex + '].selectedIndex'] = selectedIndex;
    newData['eles[' + compindex + '].selectedCateId'] = categoryId;
    newData['eles[' + compindex + '].classifyLevel'] = classifyLevel;
    newData['eles[' + compindex + '].showSubClassify'] = false;
    pageInstance.setData(newData);
    this.tapNewClassifyRefreshHandler(null, compindex, categoryId, pageInstance);
  }

  tapNewClassifyRefreshHandler = (event, componentIndex, categoryId, pageIn) => {
    let pageInstance = pageIn || app.getAppCurrentPage();
    let compindex       = componentIndex > -1 ? componentIndex : event.currentTarget.dataset.compindex;
    let compData     = pageInstance.data.eles[compindex];
    let newData      = {};
    let eventParams  = {
      refresh_object: compData.customFeature.refresh_object,
      index_segment: 'category',
      index_value: categoryId === undefined ? event.currentTarget.dataset.categoryId : categoryId
    };
    if(event && event.currentTarget && event.currentTarget.dataset.index !== undefined){
      newData['eles[' + compindex + '].selectedIndex'] = event.currentTarget.dataset.index;
    }
    if (compData.showNewClassifySelect) {
      let index = event.currentTarget.dataset.index,
        scrollLeft = 0;
      if (index > 3) {
        scrollLeft = (index - 3) * 150 + 'rpx';
      }
      newData['eles[' + compindex + '].newClassifyScrollLeft'] = scrollLeft;
      this.tapShowNewClassifySelect({currentTarget:{dataset: {compindex: compindex}}});
    }
    newData['eles[' + compindex + '].selectedCateId'] = eventParams.index_value;
    newData['eles[' + compindex + '].showSubClassify'] = false;
    pageInstance.setData(newData);
    app.tapRefreshListHandler(null, eventParams);
  }

  tapShowNewClassifySelect = (e) => {
    let dataset = e.currentTarget.dataset;
    let compindex = dataset.compindex;
    let pageInstance = app.getAppCurrentPage();
    let compData = pageInstance.data.eles[compindex];
    let showFlag = compData.showNewClassifySelect;
    pageInstance.setData({['eles[' + compindex + '].showNewClassifySelect']: !showFlag});
  }

  tapNewClassifyShowSubClassify = (event) => {
    let pageInstance = app.getAppCurrentPage();
    let compindex       = event.currentTarget.dataset.compindex;
    let compData     = pageInstance.data.eles[compindex];
    let index        = event.currentTarget.dataset.index;
    let newdata      = {};
    newdata['eles[' + compindex + '].selectedIndex'] = index;
    if (compData.selectedIndex === index){
      newdata['eles[' + compindex + '].showSubClassify'] = !compData.showSubClassify;
    } else {
      newdata['eles[' + compindex + '].showSubClassify'] = true;
    }
    pageInstance.setData(newdata);
  }

  render() {
    /**
     * 传入数据
     */ 
    const data = this.props.data;                // 组件数据
    /**
     * 组件配置对象
     */  
    const customFeature = data.customFeature;
    /**
     * 样式数据处理
     */
    const styleObj = convertStyleData(data.style);
    const containerStyleObj = {
      // height: `calc(${transformPx2Rem(data.style['height'])} + .3rem)`
    };
    const subContainerStyleObj = {
      backgroundImage: customFeature['background-image'],
      backgroundColor: customFeature['background-color'],
      opacity: customFeature['opacity'],
      fontSize: customFeature['font-size'],
      fontWeight: customFeature['font-weight'],
      fontStyle: customFeature['font-style'],
      textDecoration: customFeature['text-decoration'],
      color: customFeature['color'],
    }
    if (customFeature.mode == 2) {
      containerStyleObj['width'] = '80%';
    }
    /**
     *  组件内容处理
     */   
    let content = data.content;
    let classifyLevel = data.classifyLevel;
    let selectedIndex = data.selectedIndex;
    let $level1List = () => {
      return data.classifyData.map((item, itemIndex) => {
        if (item.category_id == data.selectedCateId) {
          return <div 
            key={itemIndex}
            className="new-classify-item selected"
            style={{color: customFeature.selectedColor}}
            onClick={this.tapNewClassifyRefreshHandler}
            data-category-id={ item.category_id }
            data-index={itemIndex}
            data-compindex={this.props.index}
            >
            <span
              className="text-span"
              style={customFeature.mode == 0 ? {backgroundColor: customFeature.selectedColor} : null}>{item.name}</span>
            {
              customFeature.mode == 1 && <span className="underline"></span>
            }
          </div>;
        } else {
          return <div key={itemIndex} className="new-classify-item"
              onClick={this.tapNewClassifyRefreshHandler}
              data-category-id={ item.category_id }
              data-index={itemIndex}
              data-compindex={this.props.index}
            >
            <span className="text-span">{item.name}</span>
          </div>;
        };
      });
    };
    /**
     * 返回组件
     */ 
    return (
      <div className={`custom-component new-classify mode-${customFeature.mode} level-${classifyLevel}`} style={styleObj}>
        {
          classifyLevel === 1 && 
          <React.Fragment>
            <div className="container" style={containerStyleObj}>
              {$level1List()}
            </div>
            {
              customFeature.mode == 2 && 
              <div className="newclassify-select-btn" onClick={this.tapShowNewClassifySelect} data-compindex={this.props.index}>
                <span className="ico-moon icon-downarrow"></span>
              </div>
            }
          </React.Fragment>
        }
        {
          classifyLevel === 2 &&
          <React.Fragment>
            <div className="container">
              {
                data.classifyData.map((item, itemIndex) => {
                  return <div
                      key={itemIndex}
                      className={`new-classify-item ${itemIndex == data.selectedIndex ? 'selected' : ''}`}
                      style={itemIndex == data.selectedIndex ? {color: customFeature.selectedColor} : null }
                      onClick={(e) => {
                        if (item.subclass[0]) {
                          this.tapNewClassifyShowSubClassify(e);
                        } else {
                          this.tapNewClassifyRefreshHandler(e);
                        }
                      }}
                      data-category-id={ item.category_id }
                      data-index={itemIndex}
                      data-compindex={this.props.index}
                    >
                    {
                      item.category_id == '' ? <span className="text-span">全部</span> : <span className="text-span">{item.name}</span>
                    }
                    {
                      item.category_id != '' && item.subclass[0] &&
                      <span className="triangle" style={itemIndex == data.selectedIndex ? {borderTopColor: customFeature.selectedColor} : null}></span>
                    }
                    {
                      itemIndex != data.classifyData.length - 1 && <span className="divide-line"></span>
                    }
                  </div>
                })
              }
            </div>
            {
              data.showSubClassify && 
              <div className="new-classify-subclassify" style={subContainerStyleObj}>
                {
                  data.classifyData.map((item, itemIndex) => (
                    itemIndex == data.selectedIndex && <div className="sub-classify-item-list" key={itemIndex}>
                      {
                        item.subclass.map((subItem, subItemIndex) => 
                          <div key={subItemIndex} className={`sub-classify-item ${subItem.category_id == data.selectedCateId ? 'selected': ''}`}
                            style={{
                              color: subItem.category_id == data.selectedCateId ? customFeature.selectedColor : '',
                              borderColor: subItem.category_id === data.selectedCateId && data.customFeature.mode == 1 ? data.customFeature.selectedColor : ''
                            }}
                            onClick={this.tapNewClassifyRefreshHandler}
                            data-category-id={subItem.category_id}
                            data-compindex={this.props.index}
                            >
                            {
                              console.log(subItem)
                            }
                            <span className="text-span" style={{
                              backgroundColor: subItem.category_id === data.selectedCateId && data.customFeature.mode == 0 ? data.customFeature.selectedColor : ''
                            }}>{subItem.name}</span>
                          </div>
                        )
                      }
                    </div>
                  ))
                }
              </div>
            }
          </React.Fragment>
        }
        {
          customFeature.mode == 2 && data.showNewClassifySelect && 
          <div className="newclassify-select-wrap">
            <div className="newclassify-select-main">
              <div className="newclassify-select-btn" onClick={this.tapShowNewClassifySelect} data-compindex={this.props.index}>
                <span className="ico-moon icon-uparrow"></span>
              </div>
              <div className="newclassify-list-wrap">
                {$level1List()}
              </div>
            </div>
          </div>
        }
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/custom-component/new-classify-custom-component/NewClassifyCustomComponent.jsx